import { FirebaseApp, FirebaseOptions, getApps, initializeApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || undefined,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.appId &&
    firebaseConfig.authDomain &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.projectId,
);

export const firebaseApp: FirebaseApp | undefined = isFirebaseConfigured
  ? getApps()[0] || initializeApp(firebaseConfig)
  : undefined;

export const firestoreDb: Firestore | undefined = firebaseApp
  ? getFirestore(firebaseApp)
  : undefined;

export const firebaseAuth: Auth | undefined = firebaseApp
  ? getAuth(firebaseApp)
  : undefined;
